import { Sparkles, ArrowRight } from "lucide-react";
import { InstallButton } from "./InstallButton";
import { HERO, ANCHORS } from "../lib/copy";

export const Hero = ({ onReadSubtext, onSampleRedFlag, onSampleHealthy }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative px-5 sm:px-8 pt-12 sm:pt-20 pb-10 sm:pb-14 max-w-3xl mx-auto"
    >
      <div className="ss-rule mb-8" data-testid="hero-eyebrow">
        <span>{ANCHORS.positioning}</span>
      </div>

      <div className="flex items-center gap-3 mb-7">
        <div
          className="w-11 h-11 rounded-2xl flex items-center justify-center"
          style={{
            background:
              "linear-gradient(135deg, #f0c8a8 0%, #d99680 40%, #c97a4f 100%)",
            boxShadow:
              "0 1px 0 rgba(255,255,255,0.5) inset, 0 6px 14px -6px rgba(201,122,79,0.55)",
          }}
          aria-hidden
        >
          <Sparkles className="w-5 h-5" strokeWidth={2.5} color="#ffffff" />
        </div>
        <p
          className="ss-display text-xl sm:text-2xl"
          data-testid="brand-name"
          style={{ color: "var(--ss-ink)", letterSpacing: "0" }}
        >
          DateWise <span style={{ color: "var(--ss-gold)" }}>Wingman</span>
        </p>
      </div>

      <h1
        className="ss-display-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-5"
        data-testid="hero-headline"
        style={{ color: "var(--ss-ink)" }}
      >
        {HERO.h1}
      </h1>

      <p
        className="text-lg sm:text-xl leading-relaxed mb-10 max-w-2xl"
        data-testid="hero-subheadline"
        style={{ color: "var(--ss-ink-2)", fontWeight: 500 }}
      >
        {HERO.subheadline}
      </p>

      <div className="mb-6">
        <button
          data-testid="hero-primary-cta"
          onClick={onReadSubtext}
          className="ss-cta ss-cta-mode-primary text-base sm:text-lg px-7 py-4"
        >
          {HERO.primary_cta}
          <ArrowRight className="w-5 h-5" strokeWidth={2.25} />
        </button>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 sm:gap-3 mt-4">
        <button
          data-testid="hero-sample-redflag-btn"
          onClick={onSampleRedFlag}
          className="ss-ghost-sm"
        >
          See a red-flag example
        </button>
        <button
          data-testid="hero-sample-healthy-btn"
          onClick={onSampleHealthy}
          className="ss-ghost-sm"
        >
          See a healthy example
        </button>
      </div>

      <InstallButton />
    </section>
  );
};
